import { render, staticRenderFns } from "./TrackingTransportServiceForm.vue?vue&type=template&id=0c832a54&scoped=true&"
import script from "./TrackingTransportServiceForm.vue?vue&type=script&lang=js&"
export * from "./TrackingTransportServiceForm.vue?vue&type=script&lang=js&"
import style0 from "./TrackingTransportServiceForm.vue?vue&type=style&index=0&id=0c832a54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c832a54",
  null
  
)

export default component.exports